(() => {
  if (window.cmaJourneyMeasurementBound) return;
  window.cmaJourneyMeasurementBound = true;
  const publish = (name, data) => {
    try {
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
      if (typeof window.Shopify?.analytics?.publish !== 'function') return;
      Promise.resolve(window.Shopify.analytics.publish('cma:' + name, data)).catch(() => {});
    } catch {}
  };
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (!link || !link.closest('.cma-section, .cma-unit-story, header, footer')) return;
    const destination = new URL(link.href, location.origin);
    if (!['https:', 'http:'].includes(destination.protocol)) return;
    const route = destination.origin === location.origin ? destination.pathname : destination.hostname === 'pe.aidaos.io' ? 'aida_product_economics' : 'external';
    publish('journey_clicked', {source: location.pathname, destination: route, action: link.dataset.cmaInterestDesign ? 'availability_interest' : destination.hash === '#design-explorer' ? 'configure_design' : 'navigate'});
  });
  document.addEventListener('click', event => {
    const action = event.target.closest?.('[data-next-action]');
    if (action) publish('calculator_action_selected', {source: location.pathname, action: action.dataset.nextAction});
  });
})();
